import FormattedDate from './formatted-date';
import formatDate from './format-date';
export default {
  FormattedDate: FormattedDate
};
export { formatDate };
//# sourceMappingURL=index.js.map